import { HeyLightCheckoutFormData } from "./HeyLightCheckoutForm.tsx";
import { createHeyLightAdapterAxiosClient } from "./createHeyLightAdapterAxiosClient.ts";
import { BusinessType } from "../MoneyTransfer/BusinessType.tsx";
import { useState } from "react";
import { HeyLightOrderDTO } from "./heyLightOrderDTO.ts";
import { AnalyticsParamsBag } from "../MoneyTransfer/AnalyticsParamsBag.ts";
import { ItemType } from "../NormasTeachingCheckout/CheckoutData.ts";

function ensurePhoneDialCodeHasPlus(countryCode: string): string {
  return countryCode.startsWith("+") ? countryCode : `+${countryCode}`;
}
export function useCreateHeyLightOrder() {
  const [loading, setLoading] = useState(false);
  const createHeyLightOrder = async (
    data: HeyLightCheckoutFormData,
    productId: string,
    analyticsParams?: AnalyticsParamsBag,
    newFlow?: boolean,
    productType?: ItemType,
  ) => {
    try {
      setLoading(true);
      const { data: order } =
        await createHeyLightAdapterAxiosClient().post<HeyLightOrderDTO>(
          `/order`,
          {
            analytics: analyticsParams,
            email: data.email,
            firstName: data.name,
            lastName: data.surname,
            contactNumber: {
              countryCode: ensurePhoneDialCodeHasPlus(
                data.phoneNumber.countryCode,
              ),
              number: data.phoneNumber.number,
            },
            productId,
            participants: data.participants,
            invoiceInfo: data.invoiceRequired
              ? data.businessType === BusinessType.Person
                ? {
                    requireInvoice: true,
                    businessType: BusinessType.Person,
                  }
                : {
                    requireInvoice: true,
                    businessType: BusinessType.IndividualCompany,
                    pec: data.pec ? data.pec : undefined,
                    sdiCode: data.sdiCode,
                    vat: data.vat,
                  }
              : {
                  requireInvoice: false,
                },
            isNewFlow: !(newFlow === undefined || !newFlow),
            productType: productType || ItemType.Product,
            bundleParticipants: data.bundleParticipants,
            coupon: data.coupon,
            promos: data.promos,
          },
        );

      return {
        order,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    createHeyLightOrder,
    loading,
  };
}
